export const ASK_TO_BUY = 0;
export const CONFIRM_CANCEL_PURCHASE = 1;
export const OFFER_CONFIRMED = 2;
export const ITEM_DELIVERED = 3;
export const ITEM_NOT_AVAILABLE = 4;
export const ITEM_SOLD = 5;
export const SELLER_LEFT_COMMUNITY = 6;
export const BUYER_LEFT_COMMUNITY = 7;
export const ITEM_REMOVED = 8;
